<div class="filters">
  <input
    *ngFor="let fieldName of this.filterFields"
    type="text"
    class="form-control filter"
    [placeholder]="fieldName"
    [editable]="false"
    [ngbTypeahead]="searchFor(fieldName)"
    [attr.disabled]="(disabledFor(fieldName) | async) ? true : null"
    [value]="this.filter$s.get(fieldName).value | async"
    (click)="this.filter$s.get(fieldName).click.next($event.target.value)"
    (focus)="this.filter$s.get(fieldName).focus.next($event.target.value)"
    (selectItem)="this.filter$s.get(fieldName).value.next($event.item)"
  />
</div>
<div *ngIf="this.data$ | async as data; else noData">
  <ngx-charts-line-chart
    [results]="data"
    [view]="[600, 300]"
    [xAxis]="true"
    [yAxis]="true"
    [showXAxisLabel]="true"
    [showYAxisLabel]="true"
  ></ngx-charts-line-chart>
</div>
<ng-template #noData>
  {{'Select all filters to load graph.' | translate}}
</ng-template>
